/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiIntegrationsObjectsIntegrationType } from './WebApiIntegrationsObjectsIntegrationType';
import {
    WebApiIntegrationsObjectsIntegrationTypeFromJSON,
    WebApiIntegrationsObjectsIntegrationTypeFromJSONTyped,
    WebApiIntegrationsObjectsIntegrationTypeToJSON,
} from './WebApiIntegrationsObjectsIntegrationType';
import type { WebApiMemberDtoRefundInfoDto } from './WebApiMemberDtoRefundInfoDto';
import {
    WebApiMemberDtoRefundInfoDtoFromJSON,
    WebApiMemberDtoRefundInfoDtoFromJSONTyped,
    WebApiMemberDtoRefundInfoDtoToJSON,
} from './WebApiMemberDtoRefundInfoDto';
import type { WebApiModelsEnumerationTypesExternalPaymentStatus } from './WebApiModelsEnumerationTypesExternalPaymentStatus';
import {
    WebApiModelsEnumerationTypesExternalPaymentStatusFromJSON,
    WebApiModelsEnumerationTypesExternalPaymentStatusFromJSONTyped,
    WebApiModelsEnumerationTypesExternalPaymentStatusToJSON,
} from './WebApiModelsEnumerationTypesExternalPaymentStatus';
import type { WebApiModelsEnumerationTypesPaymentType } from './WebApiModelsEnumerationTypesPaymentType';
import {
    WebApiModelsEnumerationTypesPaymentTypeFromJSON,
    WebApiModelsEnumerationTypesPaymentTypeFromJSONTyped,
    WebApiModelsEnumerationTypesPaymentTypeToJSON,
} from './WebApiModelsEnumerationTypesPaymentType';

/**
 * 
 * @export
 * @interface WebApiMemberDtoExternalPaymentDto
 */
export interface WebApiMemberDtoExternalPaymentDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiMemberDtoExternalPaymentDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof WebApiMemberDtoExternalPaymentDto
     */
    memberId?: number;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoExternalPaymentDto
     */
    externalId?: string | null;
    /**
     * 
     * @type {WebApiIntegrationsObjectsIntegrationType}
     * @memberof WebApiMemberDtoExternalPaymentDto
     */
    integrationType?: WebApiIntegrationsObjectsIntegrationType;
    /**
     * 
     * @type {Date}
     * @memberof WebApiMemberDtoExternalPaymentDto
     */
    invoiceDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof WebApiMemberDtoExternalPaymentDto
     */
    payDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof WebApiMemberDtoExternalPaymentDto
     */
    dueDate?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiMemberDtoExternalPaymentDto
     */
    balanceAmount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiMemberDtoExternalPaymentDto
     */
    totalAmount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoExternalPaymentDto
     */
    customerName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoExternalPaymentDto
     */
    payUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoExternalPaymentDto
     */
    paymentLinkId?: string | null;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesPaymentType}
     * @memberof WebApiMemberDtoExternalPaymentDto
     */
    paymentType?: WebApiModelsEnumerationTypesPaymentType;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoExternalPaymentDto
     */
    connectedYear?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoExternalPaymentDto
     */
    invoiceUrl?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof WebApiMemberDtoExternalPaymentDto
     */
    invoiceUrlCreatedAt?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoExternalPaymentDto
     */
    documentId?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof WebApiMemberDtoExternalPaymentDto
     */
    settledAt?: Date | null;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesExternalPaymentStatus}
     * @memberof WebApiMemberDtoExternalPaymentDto
     */
    status?: WebApiModelsEnumerationTypesExternalPaymentStatus;
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoExternalPaymentDto
     */
    createdByName?: string | null;
    /**
     * 
     * @type {WebApiMemberDtoRefundInfoDto}
     * @memberof WebApiMemberDtoExternalPaymentDto
     */
    refund?: WebApiMemberDtoRefundInfoDto;
    /**
     * 
     * @type {Date}
     * @memberof WebApiMemberDtoExternalPaymentDto
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof WebApiMemberDtoExternalPaymentDto
     */
    updatedAt?: Date | null;
}

/**
 * Check if a given object implements the WebApiMemberDtoExternalPaymentDto interface.
 */
export function instanceOfWebApiMemberDtoExternalPaymentDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiMemberDtoExternalPaymentDtoFromJSON(json: any): WebApiMemberDtoExternalPaymentDto {
    return WebApiMemberDtoExternalPaymentDtoFromJSONTyped(json, false);
}

export function WebApiMemberDtoExternalPaymentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiMemberDtoExternalPaymentDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'memberId': !exists(json, 'memberId') ? undefined : json['memberId'],
        'externalId': !exists(json, 'externalId') ? undefined : json['externalId'],
        'integrationType': !exists(json, 'integrationType') ? undefined : WebApiIntegrationsObjectsIntegrationTypeFromJSON(json['integrationType']),
        'invoiceDate': !exists(json, 'invoiceDate') ? undefined : (json['invoiceDate'] === null ? null : new Date(json['invoiceDate'])),
        'payDate': !exists(json, 'payDate') ? undefined : (json['payDate'] === null ? null : new Date(json['payDate'])),
        'dueDate': !exists(json, 'dueDate') ? undefined : (json['dueDate'] === null ? null : new Date(json['dueDate'])),
        'balanceAmount': !exists(json, 'balanceAmount') ? undefined : json['balanceAmount'],
        'totalAmount': !exists(json, 'totalAmount') ? undefined : json['totalAmount'],
        'customerName': !exists(json, 'customerName') ? undefined : json['customerName'],
        'payUrl': !exists(json, 'payUrl') ? undefined : json['payUrl'],
        'paymentLinkId': !exists(json, 'paymentLinkId') ? undefined : json['paymentLinkId'],
        'paymentType': !exists(json, 'paymentType') ? undefined : WebApiModelsEnumerationTypesPaymentTypeFromJSON(json['paymentType']),
        'connectedYear': !exists(json, 'connectedYear') ? undefined : json['connectedYear'],
        'invoiceUrl': !exists(json, 'invoiceUrl') ? undefined : json['invoiceUrl'],
        'invoiceUrlCreatedAt': !exists(json, 'invoiceUrlCreatedAt') ? undefined : (json['invoiceUrlCreatedAt'] === null ? null : new Date(json['invoiceUrlCreatedAt'])),
        'documentId': !exists(json, 'documentId') ? undefined : json['documentId'],
        'settledAt': !exists(json, 'settledAt') ? undefined : (json['settledAt'] === null ? null : new Date(json['settledAt'])),
        'status': !exists(json, 'status') ? undefined : WebApiModelsEnumerationTypesExternalPaymentStatusFromJSON(json['status']),
        'createdByName': !exists(json, 'createdByName') ? undefined : json['createdByName'],
        'refund': !exists(json, 'refund') ? undefined : WebApiMemberDtoRefundInfoDtoFromJSON(json['refund']),
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (json['updatedAt'] === null ? null : new Date(json['updatedAt'])),
    };
}

export function WebApiMemberDtoExternalPaymentDtoToJSON(value?: WebApiMemberDtoExternalPaymentDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'memberId': value.memberId,
        'externalId': value.externalId,
        'integrationType': WebApiIntegrationsObjectsIntegrationTypeToJSON(value.integrationType),
        'invoiceDate': value.invoiceDate === undefined ? undefined : (value.invoiceDate === null ? null : value.invoiceDate.toISOString()),
        'payDate': value.payDate === undefined ? undefined : (value.payDate === null ? null : value.payDate.toISOString()),
        'dueDate': value.dueDate === undefined ? undefined : (value.dueDate === null ? null : value.dueDate.toISOString()),
        'balanceAmount': value.balanceAmount,
        'totalAmount': value.totalAmount,
        'customerName': value.customerName,
        'payUrl': value.payUrl,
        'paymentLinkId': value.paymentLinkId,
        'paymentType': WebApiModelsEnumerationTypesPaymentTypeToJSON(value.paymentType),
        'connectedYear': value.connectedYear,
        'invoiceUrl': value.invoiceUrl,
        'invoiceUrlCreatedAt': value.invoiceUrlCreatedAt === undefined ? undefined : (value.invoiceUrlCreatedAt === null ? null : value.invoiceUrlCreatedAt.toISOString()),
        'documentId': value.documentId,
        'settledAt': value.settledAt === undefined ? undefined : (value.settledAt === null ? null : value.settledAt.toISOString()),
        'status': WebApiModelsEnumerationTypesExternalPaymentStatusToJSON(value.status),
        'createdByName': value.createdByName,
        'refund': WebApiMemberDtoRefundInfoDtoToJSON(value.refund),
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt === null ? null : value.updatedAt.toISOString()),
    };
}

